export default __webpack_public_path__ + "static/media/PayoutBfc.71cb07a1.svg";